import cogoToast from "cogo-toast";
const { createSlice } = require("@reduxjs/toolkit");

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    wishlistItems: [],
  },
  reducers: {
    addToWishlist(state, action) {
      const isInWishlist = state.wishlistItems.findIndex(
        (item) => item.ID === action.payload.ID
      );
      if (isInWishlist > -1) {
        // If already in wishlist, remove it and show "Wishlist removed" toast
        state.wishlistItems = state.wishlistItems.filter(
          (item) => item.ID !== action.payload.ID
        );
        cogoToast.success("Wishlist removed successfully", {
          position: "bottom-left",
        });
      } else {
        // If not in wishlist, add it and show "Added to wishlist" toast
        state.wishlistItems.push(action.payload);
        cogoToast.success("Added to wishlist", { position: "bottom-left" });
      }
    },
    deleteFromWishlist(state, action) {
      state.wishlistItems = state.wishlistItems.filter(
        (item) => item.ID !== action.payload
      );
      cogoToast.error("Removed from wishlist", { position: "bottom-left" });
    },
    deleteAllFromWishlist(state) {
      state.wishlistItems = [];
    },
  },
});

export const { addToWishlist, deleteFromWishlist, deleteAllFromWishlist } =
  wishlistSlice.actions;
export default wishlistSlice.reducer;
